import type { loader } from '../index.tsx'
import { useLoaderData } from '@remix-run/react'
import { cn } from '#app/utils/misc.tsx'
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from '#app/components/ui/carousel.tsx'

export default function ProductImages() {
	const { product } = useLoaderData<typeof loader>()

	//console.log(product)
	//const images = product.images

	// Check for own images first, then parent images
	const hasOwnImages = product.images && product.images.length >= 1
	const hasParentImages = Boolean(
		(
			product as typeof product & {
				parentImages?: Array<{ id: number; image: string }>
			}
		).parentImages?.length,
	)

	// Use product images if available, otherwise use parent images
	const imagesToDisplay = hasOwnImages
		? product.images
		: hasParentImages
			? (
					product as typeof product & {
						parentImages: Array<{ id: number; image: string }>
					}
				).parentImages
			: []

	return (
		<div className="col-span-1 lg:col-span-7">
			<Carousel className="relative">
				<CarouselContent>
					{imagesToDisplay.map((image) => (
						<CarouselItem key={image.id}>
							<img
								src={image.image ?? ''}
								alt={`${product.name ?? ''}-${product.id}`}
								className="rounded-lg"
							/>
						</CarouselItem>
					))}
				</CarouselContent>
				{imagesToDisplay.length > 1 && (
					<>
						<CarouselPrevious className="absolute left-2" />
						<CarouselNext className="absolute right-2" />
					</>
				)}
			</Carousel>
		</div>
	)
}
